var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('app-bar'),_c('v-main',[_c('router-view')],1),_c('app-snackbar',{staticClass:"snackbar",attrs:{"snackbar-message":_vm.snackbarMessage,"show-snackbar":_vm.showSnackbar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }